import { render, staticRenderFns } from "./ListProvincia.vue?vue&type=template&id=c6fbb148&scoped=true&"
import script from "./ListProvincia.vue?vue&type=script&lang=js&"
export * from "./ListProvincia.vue?vue&type=script&lang=js&"
import style0 from "./ListProvincia.vue?vue&type=style&index=0&id=c6fbb148&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fbb148",
  null
  
)

export default component.exports